export default __webpack_public_path__ + "static/media/face-nina.b1ba2d3e.svg";